document.addEventListener('DOMContentLoaded', function() {
  const scrollBtn = document.querySelector('a[href="#scroll-next"]');
  if (scrollBtn) {
    scrollBtn.addEventListener('click', function(e) {
      e.preventDefault();
      const nextSection = document.getElementById('product_list_fa6P9H');
      if (nextSection) {
        nextSection.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }
});
